import { RaceProgressMarkRaw } from "./interfaces/race_progress_mark_raw.interface";

export class MarkClass {
  marshal!: number;
  joker!: number;
  penaltyTime!: number;
  // obligatory!: number;
  // manualEdit!: string;
  // time!: number;
  // delta!: number;
  // deltaLap!: number;
  // deltaStart!: number;
  // deltaLider!: number;
  enterMark!: number;
  maxTime!: number;
  minTime!: number;


  constructor(obj: RaceProgressMarkRaw) {
    this.update(obj);
  }

  update(obj: RaceProgressMarkRaw) {
    this.marshal = +obj.marshal;
    this.joker = obj.joker || 0;
    this.penaltyTime = obj.penaltyTime;
    // this.obligatory = obj.obligatory || 0;
    // this.manualEdit = obj.manualEdit || '';
    // this.time = obj.time || 0;
    // this.delta = obj.delta || 0;
    // this.deltaLap = obj.deltaLap || 0;
    // this.deltaStart = obj.deltaStart || 0;
    // this.deltaLider = obj.deltaLider || 0;

    this.enterMark = obj.enterMark || 0;
    this.maxTime = obj.maxTime || 0;
    this.minTime = obj.minTime || 0;
  }
}
